import React from 'react';
import Modal from 'react-responsive-modal';
import _ from 'lodash';
import moment from 'moment';
import Translate from 'translate';

class BillModalLEC extends React.Component {
  constructor( props ) {
    super( props );
  }

  render() {
    const { data, onClose, open } = this.props;

    return (
      <Modal little
             modalClassName="col-md-6 client-folder p-0"
             open={open}
             onClose={onClose}>

        <div className="p-3 mb-4 bg-blue">
        <h5 className="m-0 d-inline-block"><Translate id="BillNumber"/> {_.get( data, 'DocNumber' )}</h5>
        </div>

        <div className="row mb-3 px-3">
          <div className="col-md-5">
            <p className="mb-1"><b><Translate id="MovementType"/>:</b> {_.get( data, 'MovementType', '-' )}</p>
            
          </div>
          <div className="col-md-3">
            <p className="mb-1"><b><Translate id="BillDate"/>:</b> { data.Date ? moment.unix( _.get( data, 'Date', '0' ) /1000 ).format( 'MM/DD/YYYY' ) : '-'}</p>
          </div>
          <div className="col-md-4">
            <p className="mb-1"><b><Translate id="BillAmount"/>:</b> {_.get( data, 'Amount', '-' )}</p>
          </div>

        </div>
        <div className="row mb-3 px-3">
          <div className="col-md-5">
            <p className="mb-1"><b><Translate id="Status"/>:</b> {_.get( data, 'Status', '-' )}</p>
            
            
          </div>
          <div className="col-md-3">
            <p className="mb-1"><b><Translate id="dueDate"/>:</b> { data.DueDate  ? moment.unix( _.get( data, 'DueDate', '0' ) / 1000 ).format( 'MM/DD/YYYY' ) : '-' }</p>
          </div>
          <div className="col-md-4">
            <p className="mb-1"><b><Translate id="PaidAmount"/>:</b> {_.get( data, 'PaymentAmount', '-' )}</p>
          </div>

        </div>
      </Modal>
    )
  }
}

module.exports = BillModalLEC;



// WEBPACK FOOTER //
// ./routes/app/components/Agent/ClientFolder/BillModalLEC/index.js